var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChevronDownRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "lh7lioufya"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.760784 0 0 0 0 0.109804 0 0 0 0 0.109804 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#lh7lioufya)",
    transform: "translate(-60 -1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#DB544A",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L4 4 8 0",
    transform: "translate(60 1) translate(4 6)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChevronDownRed);
export default __webpack_public_path__ + "static/media/ic-chevron-down-red.033f6b3a87793cfbb8626e8556d4c1c4.svg";
export { ForwardRef as ReactComponent };